import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import {
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
  MAT_MOMENT_DATE_FORMATS,
  MomentDateAdapter
} from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ConfirmationAddDeputyDialogConfirm } from '@coin/shared/core/util-models';
import { MatFormField, MatInput, MatSuffix } from '@angular/material/input';
import { MatDatepickerInput, MatDatepicker } from '@angular/material/datepicker';
import { FormsModule } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';
import { V2ButtonComponent, V2DialogFrameComponent, V2DialogFooterComponent } from '@coin/shared/core/ui-storybook';

@Component({
  selector: 'coin-c-confirmation-add-deputy-dialog',
  templateUrl: './confirmation-add-deputy-dialog.component.html',
  styleUrls: ['./confirmation-add-deputy-dialog.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } }
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    V2DialogFrameComponent,
    MatFormField,
    MatInput,
    MatDatepickerInput,
    FormsModule,
    MatIcon,
    MatSuffix,
    MatDatepicker,
    V2DialogFooterComponent,
    V2ButtonComponent,
    TranslatePipe
  ]
})
export class ConfirmationAddDeputyDialogComponent implements OnInit {
  private readonly dialogRef = inject<MatDialogRef<ConfirmationAddDeputyDialogComponent>>(MatDialogRef);

  startsAt: Date;
  endsAt: Date;

  public ngOnInit(): void {
    // temporary workaround to not break unit test
    if (typeof this.dialogRef.addPanelClass === 'function') {
      this.dialogRef.addPanelClass('d1r-dialog-container');
    }
  }

  public cancel(): void {
    this.dialogRef.close();
  }

  public confirm(): void {
    this.dialogRef.close({
      startsAt: this.startsAt,
      endsAt: this.endsAt,
      clickedButton: 'Confirm'
    } as ConfirmationAddDeputyDialogConfirm);
  }
}
